<template>
    <div class="stat-square">
        <div class="label">{{ label }}</div>
        <div class="value">{{ value | placeholderWhenNoData }}</div>
        <div class="info-link">
          <span v-if="linkurl" @click="NavigateTo()">{{ linklabel }}</span>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'StatSquare',
  props: {
    value: {
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    linklabel: {
      type: String,
      required: false,
    },
    linkurl: {
      type: String,
      required: false,
    },
  },
  computed: {
    ...mapGetters('userStore', [
      'isPrincipal'
    ]),
  },
  methods: {
    NavigateTo() {
      if (this.isPrincipal) {
        this.$router.push({
          path: this.linkurl,
        });
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .stat-square {
    @apply ut-px-10 ut-text-center ut-w-full;
    background-color: #F8F8F8;
    border-radius: 6px;
    padding-top: 28px;
    padding-bottom: 22px;

    &.sm-w-full {
       @apply ut-w-full;
    }

    @screen md {
      padding-top: 28px;
    padding-bottom: 28px;
      @apply ut-px-1;
      border-radius: 3px;

    }

    .value {
      @apply ut-mb-2;
      color: #233A3A;
      font-size: 24px;
      font-weight: 600;
      letter-spacing: -0.34px;
      text-align: center;
    }

    .label {
      @apply ut-mb-2;
      opacity: 0.6;
      color: #233A3A;
      font-size: 14px;
      line-height: 16px;
    }
    .info-link {
      color: #00AB64;
      font-size: 14px;
      font-weight: 600;
      letter-spacing: -0.34px;
      text-align: center;
      height: 1rem;
      span {
        cursor: pointer;
      }
    }
  }
</style>
